import Vue from 'vue';
import VueRouter from 'vue-router';

const { getObjectValue } = require('@root/helpers');
const store = require('@root/store');

Vue.use(VueRouter);

let routes = [
	{
		path: '/dashboard',
		redirect: '/configurator',
	},
	require('./quote-builder'),
	require('./quotes'),
	require('./proposals'),
	require('./messages'),
	require('./activity'),
];

const user = getObjectValue('Spark.state.user', window);
const currentTeam = getObjectValue('Spark.state.currentTeam', window, {});

// routes.unshift({
// 	path:     '/dashboard',
// 	redirect: getObjectValue('team_settings.main_path', currentTeam, '/')
// });
// routes.unshift({
// 	path:      '/products',
// 	component: require('@views/Products').default,
// 	meta:      {
// 		showButton: true,
// 		title:      'Configurator',
// 		icon:       ['fas', 'bars'],
// 		primary:    true,
// 		in_privacy: true,
// 		search:     {
// 			placeholder: 'Search Quotes & Orders',
// 			show:        true
// 		}
// 	}
// });

if (
	_.find(
		getObjectValue('roles', user, []),
		(item) => ['Super Admin', 'Admin', 'DSM'].indexOf(item.name) >= 0
	) !== undefined
) {
	routes.push(require('./managers'));
}

if (
	_.find(
		getObjectValue('roles', user, []),
		(item) => ['Super Admin', 'Admin'].indexOf(item.name) >= 0
	) !== undefined
) {
	routes.push(require('./admin'));
}

routes.push(require('./document-center'));

routes.push({
	path: '*',
	component: require('@views/errors/404').default,
});

const router = new VueRouter({
	base: '/',
	mode: 'history',
	routes,
});

router.beforeEach(require('./guards/before-each'));

export default router;
